import { all, select, takeEvery, fork, put } from 'redux-saga/effects'

// action
import {
	mainActions,
	adminActions,
	configActions,
	routeActions,
} from '@redux/store/index'

// lib
import { Logger } from '@utils'
import { firstMainTap, firstAdminTap } from '@redux/store/core/config.store'

// type
import type { ConfigStateType, MenuType, TabType } from '@redux/types'

function* getMenu() {
	try {
		yield put(adminActions.TRIGGER_GET_MENU_LIST(true))
	} catch (error) {
		Logger.warn(error)
	}
}

function* menuSaga() {
	try {
		const mode: ConfigStateType['mode'] = yield select(state => state.config.mode)
		const configTabList: TabType[] = yield select(state => state.config.tabList)
		const menu: MenuType[] = yield select(state => state.main.menu)
		const defaultTab: TabType = mode === 'main' ? firstMainTap : firstAdminTap

		const firstMenu: MenuType = menu.filter(aMenu => aMenu.id.startsWith('OP-'))[0]
		const firstTab: TabType =
			firstMenu !== undefined
				? {
						id: firstMenu.id,
						name: firstMenu.name,
						path: firstMenu.to ?? '',
						i18n: firstMenu.i18n ?? [],
				  }
				: {
						id: 'main',
						name: 'Main',
						path: '/main/empty',
						i18n: [],
				  }
		const newTabList: TabType[] =
			firstMenu !== undefined ? [defaultTab, { ...firstTab }] : []

		const isMainMode: boolean = mode === 'main'
		const isDefaultConfigTabList: boolean =
			configTabList.length === 1 && configTabList[0].id === 'home'

		if (isMainMode && isDefaultConfigTabList) {
			yield put(configActions.TAB_LIST(newTabList))
			yield put(routeActions.NAVIGATE_PATH(firstTab.path))
		}

		if (mode === 'main') {
			if (configTabList.length === 0) {
				yield put(routeActions.NAVIGATE_PATH('/main/home'))
			} else {
				yield put(routeActions.NAVIGATE_PATH(firstTab.path))
			}
		}

		yield put(configActions.TAB_LIST([defaultTab]))
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(mainActions.TRIGGER_GET_MENU, getMenu)
	yield takeEvery(mainActions.MENU, menuSaga)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
